import { jsx as _jsx } from "react/jsx-runtime";
import ColorContrastChecker from 'color-contrast-checker';
import { CustomFieldType } from '@tribeplatform/gql-client/types';
import { Badge } from '@tribeplatform/react-ui-kit/Badge';
import { CustomFieldSubtype, getFieldSetting, } from '../utils';
export const PillView = ({ value, field, trueText, falseText, }) => {
    const contrastChecker = new ColorContrastChecker();
    let text;
    let color;
    let textColor;
    if ((field === null || field === void 0 ? void 0 : field.type) === CustomFieldType.boolean) {
        if (!trueText && !falseText)
            trueText = 'Checked';
        text = value ? trueText : falseText;
        if (!text)
            return null;
    }
    else
        text = value;
    if (!text)
        return null;
    const subtype = getFieldSetting(field, 'subtype');
    if (subtype === CustomFieldSubtype.SELECT) {
        const selectOptions = getFieldSetting(field, 'selectOptions');
        const currentOption = selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.find(option => (option === null || option === void 0 ? void 0 : option.value) === value);
        color = currentOption === null || currentOption === void 0 ? void 0 : currentOption.color;
        if (color)
            textColor =
                contrastChecker.hexToLuminance(color) < 0.5 ? '#ffffff' : '#000000';
    }
    return (_jsx("div", { children: _jsx(Badge, { size: "lg", variant: "secondary", style: { backgroundColor: color, color: textColor }, children: text }, void 0) }, void 0));
};
//# sourceMappingURL=PillView.js.map